import { track } from '@bnnvara/analytics/src/track';
import React from 'react';

import * as S from '../styled';

const MenuButton = () => (
  <>
    <S.HomeButton
      type="link"
      href="/"
      variant="text"
      onClick={() => {
        track('bnnvara-menu', 'click', 'home');
      }}
    >
      Home
    </S.HomeButton>
    <S.HomeButton
      type="link"
      href="/catalogus/programmas"
      variant="text"
      onClick={() => {
        track('bnnvara-menu', 'click', 'titels');
      }}
    >
      Titels
    </S.HomeButton>
  </>
);

export default MenuButton;
